const data = [
    {
        imgUrl: 'https://cdn.app.1bill.ai/suppliers/logos/agl-logo-primary.png',
        productTypeImgUrl: 'assets/bills/icons/light_bulb.svg',
        title: 'Save $58',
        subtitle: 'every month with AGL',
        description: 'compared to your current provider (Energy Australlia)',
        url: '',
        btnLabel: 'Apply now',
    },
    {
        imgUrl: 'https://cdn.app.1bill.ai/suppliers/logos/logo-red-energy.png',
        productTypeImgUrl: 'assets/bills/icons/fire.svg',
        title: 'Save $68',
        subtitle: 'every month with AGL',
        description: 'compared to your current provider (Energy Australlia)',
        url: '',
        btnLabel: 'Apply now',
    }
]
export default data;

